<template>
    <div class="wizard-courses-card" :class="{'ishover': hover}">
        <div class="wizard-courses-card-container">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        hover:Boolean
    }
}
</script>
<style lang="scss" scoped>
@import "../../../sass/_variables.scss";
.wizard-courses-card{
    width: 100%;
    background-color: $blue-darker;
    color: white;
    transition: 0.3s;
    &.disabled {
        pointer-events: none;
        background-color: $card-course-disabled;

        .wizard-courses-card-container {
            > div:not(.sold-out) {
                h5, p {
                    color: $text-course-disabled;
                }
                hr {
                    border-top-color: $grey;
                }
            }
        }
    }
    &-container{
        padding: 2rem 1rem;
    }
    .text-grey{
        color: $grey;
        font-size: 16px;
    }
    .text-blue{
        color: $text-blue-card;
        font-size: 18px;
        font-weight: bold;
    }
}
.ishover{
    &:hover{
        background-color: $blue;
        cursor: pointer;
    }
}
</style>
